export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative aspect-video rounded shadow-[inset_0_0_0_1px_rgba(255,255,255,0.05)] flex flex-col items-center justify-center">
      <div className="relative z-10 flex flex-col items-center justify-center gap-2 max-w-56 text-center">
        <h2>잠금 해제된 독점 보상 없음</h2>
        <p className="text-sm text-gray-11">
          쇼 체크인하거나 아이템을 구매해 콘텐츠, 음악, 응모 등 다양한 보상을 잠금 해제하세요.
        </p>
      </div>
    </div>
  )
}
